function initVwoCollectionV2BackToTop() {
  if (!document.body.classList.contains('vwo-collection-v2')) return;

  var backToTop = document.getElementById('VwoBackToTop');
  if (!backToTop) return;

  var SHOW_AFTER = 1600;
  var ticking = false;

  function update() {
    var scrolled = window.scrollY || window.pageYOffset || 0;
    backToTop.classList.toggle('is-visible', scrolled > SHOW_AFTER);
    ticking = false;
  }

  window.addEventListener(
    'scroll',
    function () {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(update);
    },
    { passive: true }
  );

  backToTop.addEventListener('click', function () {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  });

  update();
}

function initVwoCollectionV2FloatingFilters() {
  if (!document.body.classList.contains('vwo-collection-v2')) return;

  initVwoCollectionV2BackToTop();

  var panel = document.querySelector('.new-filter .sticky-filter-panel');
  var stickyBar = document.getElementById('StickyFilterBar');
  if (!panel && !stickyBar) return;

  var SECTION_ID = panel ? panel.dataset.sectionId : null;

  /* ── Filter panel: tabs, apply, clear, dependent filters, cancel restore ── */
  if (panel) {
    var tabs = panel.querySelectorAll('.sticky-filter-panel__tab');
    var content = panel.querySelector('.sticky-filter-panel__content');
    var debounceTimer = null;
    var abortCtrl = null;
    var appliedHTML = content ? content.innerHTML : '';

    panel.addEventListener('input', function (e) {
      e.stopPropagation();
    });

    var applyBtn = document.getElementById('StickyFilterApplyBtn');
    if (applyBtn) {
      applyBtn.addEventListener('click', function () {
        var form = panel.closest('form');
        if (!form) return;
        var newParams = new URLSearchParams(new FormData(form));
        var currentUrl = new URL(window.location.href);
        ['sort_by', 'view'].forEach(function (p) {
          if (currentUrl.searchParams.has(p) && !newParams.has(p)) {
            newParams.set(p, currentUrl.searchParams.get(p));
          }
        });
        window.location.href = window.location.pathname + '?' + newParams.toString();
      });
    }

    var clearAllLink = document.getElementById('StickyClearAllLink');
    if (clearAllLink) {
      clearAllLink.addEventListener('click', function (e) {
        e.preventDefault();
        var currentUrl = new URL(window.location.href);
        var href = clearAllLink.getAttribute('href');
        if (currentUrl.searchParams.has('view')) {
          var clearUrl = new URL(href, window.location.href);
          clearUrl.searchParams.set('view', currentUrl.searchParams.get('view'));
          window.location.href = clearUrl.toString();
        } else {
          window.location.href = href;
        }
      });
    }

    panel.querySelectorAll('[data-vwo-filter-close]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var wrapper = panel.closest('.mobile-facets__wrapper');
        var summary = wrapper ? wrapper.querySelector('.mobile-facets__disclosure > summary') : null;
        if (summary) summary.click();
      });
    });

    tabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        tabs.forEach(function (t) {
          t.classList.remove('active');
        });
        tab.classList.add('active');
        var target = document.getElementById(tab.getAttribute('data-target'));
        if (target && content) {
          content.scrollTo({ top: target.offsetTop - content.offsetTop, behavior: 'smooth' });
        }
      });
    });

    if (content) {
      var groups = panel.querySelectorAll('.sticky-filter-panel__filter-group');
      content.addEventListener('scroll', function () {
        var current = 0;
        groups.forEach(function (group, i) {
          if (content.scrollTop >= group.offsetTop - content.offsetTop - 20) {
            current = i;
          }
        });
        tabs.forEach(function (t, i) {
          t.classList.toggle('active', i === current);
        });
      });
    }

    panel.querySelectorAll('.sticky-filter-panel__item').forEach(function (item) {
      var countEl = item.querySelector('.sticky-filter-panel__label-count');
      if (countEl && item.dataset.initialCount === undefined) {
        item.dataset.initialCount = countEl.textContent.trim();
      }
    });

    function setItemCount(item, count) {
      var countEl = item.querySelector('.sticky-filter-panel__label-count');
      if (countEl) countEl.textContent = '(' + count + ')';
    }

    function enableItem(item, cb) {
      item.classList.remove('is-disabled-dependent');
      var label = item.querySelector('.sticky-filter-panel__label');
      if (label) label.classList.remove('disabled');
      if (cb) cb.disabled = false;
    }

    function disableItem(item, cb) {
      item.classList.add('is-disabled-dependent');
      var label = item.querySelector('.sticky-filter-panel__label');
      if (label) label.classList.add('disabled');
      if (cb) cb.disabled = true;
    }

    function getSelectedParams() {
      var params = new URLSearchParams();
      panel.querySelectorAll('.sticky-filter-panel__checkbox:checked').forEach(function (cb) {
        params.append(cb.name, cb.value);
      });
      return params;
    }

    function restoreAllItems() {
      if (!content) return;
      content.querySelectorAll('.sticky-filter-panel__item').forEach(function (item) {
        var cb = item.querySelector('.sticky-filter-panel__checkbox');
        enableItem(item, cb);
        var countEl = item.querySelector('.sticky-filter-panel__label-count');
        if (countEl && item.dataset.initialCount !== undefined) {
          countEl.textContent = item.dataset.initialCount;
        }
      });
    }

    function applyVisibility(map) {
      content.querySelectorAll('.sticky-filter-panel__item').forEach(function (item) {
        var cb = item.querySelector('.sticky-filter-panel__checkbox');
        if (!cb) return;
        var key = cb.name + '||' + cb.value;
        var count = map.has(key) ? map.get(key) : 0;
        setItemCount(item, count);
        if (cb.checked) {
          enableItem(item, cb);
          return;
        }
        if (count === 0) {
          disableItem(item, cb);
        } else {
          enableItem(item, cb);
        }
      });
    }

    function buildAvailabilityMap(doc) {
      var map = new Map();
      var fetchedItems = doc.querySelectorAll('.sticky-filter-panel__item .sticky-filter-panel__checkbox');
      if (fetchedItems.length) {
        fetchedItems.forEach(function (cb) {
          var countEl = cb.closest('.sticky-filter-panel__item').querySelector('.sticky-filter-panel__label-count');
          var count = countEl ? parseInt(countEl.textContent.replace(/\D/g, ''), 10) : 1;
          map.set(cb.name + '||' + cb.value, count);
        });
        return map;
      }
      doc.querySelectorAll('input[type="checkbox"][name^="filter."]').forEach(function (cb) {
        var li = cb.closest('li') || cb.closest('label');
        var m = li ? li.textContent.match(/\((\d+)\)/) : null;
        var count = m ? parseInt(m[1], 10) : cb.disabled ? 0 : 1;
        map.set(cb.name + '||' + cb.value, count);
      });
      return map;
    }

    function setLoading(on) {
      if (!content) return;
      content.style.opacity = on ? '0.45' : '';
      content.style.pointerEvents = on ? 'none' : '';
    }

    function refreshDependentOptions() {
      if (!content || !SECTION_ID) return;
      var selectedParams = getSelectedParams();
      if (!selectedParams.toString()) {
        restoreAllItems();
        return;
      }
      if (abortCtrl) abortCtrl.abort();
      abortCtrl = typeof AbortController !== 'undefined' ? new AbortController() : null;
      var url = new URL(window.location.pathname, window.location.origin);
      selectedParams.forEach(function (val, key) {
        url.searchParams.append(key, val);
      });
      var existing = new URLSearchParams(window.location.search);
      ['sort_by', 'view'].forEach(function (p) {
        if (existing.has(p)) url.searchParams.set(p, existing.get(p));
      });
      url.searchParams.set('section_id', SECTION_ID);
      setLoading(true);
      var fetchOpts = abortCtrl ? { signal: abortCtrl.signal } : {};
      fetch(url.toString(), fetchOpts)
        .then(function (r) {
          return r.text();
        })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var map = buildAvailabilityMap(doc);
          if (map.size) applyVisibility(map);
          setLoading(false);
        })
        .catch(function (err) {
          if (err.name !== 'AbortError') setLoading(false);
        });
    }

    panel.addEventListener('change', function (e) {
      if (!e.target.classList.contains('sticky-filter-panel__checkbox')) return;
      clearTimeout(debounceTimer);
      debounceTimer = setTimeout(refreshDependentOptions, 300);
    });

    var details = panel.closest('details');
    if (details && content) {
      details.addEventListener('toggle', function () {
        if (details.open) return;
        content.style.opacity = '';
        content.style.pointerEvents = '';
        if (content.innerHTML !== appliedHTML) {
          content.innerHTML = appliedHTML;
        }
      });
    }
  }

  /* ── Floating bar: sort popup + filter drawer wiring ── */
  if (!stickyBar) return;

  var filterDot = document.getElementById('StickyFilterActiveDot');
  if (filterDot) {
    var params = new URLSearchParams(window.location.search);
    var hasActiveFilter = false;
    params.forEach(function (value, key) {
      if (key.startsWith('filter.') && value !== '' && value !== '0') {
        hasActiveFilter = true;
      }
    });
    if (hasActiveFilter) filterDot.hidden = false;
  }

  var container = stickyBar.closest('.facets-container-sticky');
  var menuDrawer = container ? container.querySelector('.mobile-facets__wrapper') : null;
  var drawerSummary = menuDrawer ? menuDrawer.querySelector('.mobile-facets__disclosure > summary') : null;
  var drawerDetails = menuDrawer ? menuDrawer.querySelector('.mobile-facets__disclosure') : null;
  var scrollY = 0;

  function lockBodyScroll(cls) {
    scrollY = window.scrollY || window.pageYOffset;
    document.body.style.top = '-' + scrollY + 'px';
    document.body.classList.add(cls);
  }

  function unlockBodyScroll(cls) {
    document.body.classList.remove(cls);
    document.body.style.top = '';
    window.scrollTo({ top: scrollY, behavior: 'instant' });
  }

  function openDrawer() {
    if (!drawerSummary) return;
    lockBodyScroll('filter-popup-open');
    drawerSummary.click();
  }

  if (drawerDetails) {
    new MutationObserver(function (mutations) {
      mutations.forEach(function (m) {
        if (m.type === 'attributes' && m.attributeName === 'class') {
          if (!drawerDetails.classList.contains('menu-opening') && document.body.classList.contains('filter-popup-open')) {
            unlockBodyScroll('filter-popup-open');
          }
        }
      });
    }).observe(drawerDetails, { attributes: true });
  }

  if (menuDrawer) {
    var mobileFacetsForm = menuDrawer.querySelector('form.mobile-facets');
    if (mobileFacetsForm && drawerDetails) {
      mobileFacetsForm.addEventListener('click', function (e) {
        var inner = mobileFacetsForm.querySelector('.mobile-facets__inner');
        if (inner && inner.contains(e.target)) return;
        if (drawerDetails.classList.contains('menu-opening') && drawerSummary) {
          drawerSummary.click();
        }
      });
    }
  }

  var filterBtn = stickyBar.querySelector('.sticky-filter-bar__filter');
  if (filterBtn) filterBtn.addEventListener('click', openDrawer);

  var sortPopup = document.getElementById('StickySortPopup');
  var sortOverlay = document.getElementById('StickySortOverlay');
  var sortClose = document.getElementById('StickySortClose');
  var sortForm = document.getElementById('StickySortForm');

  function openSortPopup() {
    if (!sortPopup) return;
    sortPopup.classList.add('is-open');
    lockBodyScroll('sort-popup-open');
  }

  function closeSortPopup() {
    if (!sortPopup) return;
    sortPopup.classList.remove('is-open');
    unlockBodyScroll('sort-popup-open');
  }

  var sortBtn = stickyBar.querySelector('.sticky-filter-bar__sort');
  if (sortBtn) sortBtn.addEventListener('click', openSortPopup);
  if (sortOverlay) sortOverlay.addEventListener('click', closeSortPopup);
  if (sortClose) sortClose.addEventListener('click', closeSortPopup);

  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    if (sortPopup && sortPopup.classList.contains('is-open')) {
      closeSortPopup();
      return;
    }
    if (drawerDetails && drawerDetails.classList.contains('menu-opening') && drawerSummary) {
      drawerSummary.click();
    }
  });

  if (sortForm) {
    sortForm.addEventListener('change', function (e) {
      if (!e.target.name || e.target.name !== 'sort_by') return;
      var url = new URL(window.location.href);
      url.searchParams.set('sort_by', e.target.value);
      window.location.href = url.toString();
    });
  }
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initVwoCollectionV2FloatingFilters);
} else {
  initVwoCollectionV2FloatingFilters();
}
